import axios from 'axios';
import { API_URL, DID, WLID, ADID, ONLINE_URL } from '../config/constants';

import generatePizzaPrice from '../utils/generatePizzaPrice';
import generateCustomPizzaPrice from '../utils/generateCustomPizzaPrice';
import generateFoodItemPrice from '../utils/generateFoodItemPrice';
import generateBeveragePrice from '../utils/generateBeveragePrice';
import generateSpecialPrice from '../utils/generateSpecialPrice';
import generateAddonPrice from '../utils/generateAddonPrice';
import { setCartPanel } from './panels';

export const cartReset = () => {
    return {
        type: 'CART_RESET'
    };
};

export const loadCart = (cart) => {
    return {
        type: 'LOAD_CART',
        cart
    };
};

export const cartSetReorderLoading = (reorder_loading) => {
    return {
        type: 'CART_SET_REORDER_LOADING',
        reorder_loading
    };
}

export const cartInfoUpdate = ({ prop, value }) => {

    return {
        type: 'CART_INFO_UPDATE',
        field: { prop, value }
    }
};

export const cartRemoveItem = (type, itemindex) => {

    const itemtype = type+"s";
    return {
        type: 'CART_REMOVE_ITEM',
        itemtype,
        itemindex
    };
};

export const cartAddItem = (type, item) => {

    const itemtype = type+"s";

    return {
        type: 'CART_ADD_ITEM',
        itemtype,
        item
    };
};

export const cartLoadReorderItems = (reorderInfo, currentLocation) => {

    return (dispatch) => {

        reorderInfo.pizzas.forEach((theCartPizza) => {

            if (theCartPizza.pizzatype == "custom") {
                dispatch(cartAddItem('pizza', {
                    ...theCartPizza,
                    total_item_price: generateCustomPizzaPrice(currentLocation, theCartPizza)
                }));
            }
            else {
                currentLocation.pizzas.forEach((thePizza) => {
                    if (thePizza.id == theCartPizza.item_id) {
                        dispatch(cartAddItem('pizza', {
                            ...theCartPizza,
                            total_item_price: generatePizzaPrice(thePizza, theCartPizza)
                        }));
                    }
                });
            }
        });

        reorderInfo.foodItems.forEach((theCartFoodItem) => {
            theCartFoodItem.choices = processReorderChoices(theCartFoodItem.choices);
            Object.keys(currentLocation.fooditems).forEach((theCategoryItemKey) => {
                currentLocation.fooditems[theCategoryItemKey].forEach((theFoodItem) => {
                    if (theFoodItem.id == theCartFoodItem.item_id) {
                        dispatch(cartAddItem('fooditem', {
                            ...theCartFoodItem,
                            total_item_price: generateFoodItemPrice(theFoodItem, theCartFoodItem, true)
                        }));
                    }
                });
            });
        });
        
        reorderInfo.beverages.forEach((theCartBeverage) => {
            currentLocation.beverages.forEach((theBeverage) => {
                if (theBeverage.id == theCartBeverage.item_id) {
                    dispatch(cartAddItem('beverage', {
                        ...theCartBeverage,
                        total_item_price: generateBeveragePrice(theBeverage, theCartBeverage)
                    }));
                }
            });
        });

        reorderInfo.specials.forEach((theCartSpecial) => {
            currentLocation.specials.forEach((theSpecial) => {
                if (theSpecial.id == theCartSpecial.item_id) {
                    dispatch(cartAddItem('special', {
                        ...theCartSpecial,
                        total_item_price: generateSpecialPrice(theSpecial, theCartSpecial)
                    }));
                }
            });
        });

        reorderInfo.addons.forEach((theAddon) => {
            dispatch(cartAddItem('addon', {
                ...theAddon,
                total_item_price: generateAddonPrice(theAddon)
            }));
        });
    };
};

const processReorderChoices = (reorderChoices) => {
    
    let choices = [];
    // group the choices as they should be
    reorderChoices.forEach((theChoice) => {
        if (theChoice.is_multiple == 1) {
            let found = false;
            for (let i = 0; i < choices.length; i++) {
                if (choices[i].id == theChoice.id) {
                    // same item, add it to the items
                    found = true;
                    choices[i].items.push(theChoice.item_id);
                }
            }

            if (!found) {

                // it wasn't found, add it as a new item
                theChoice.items = [theChoice.item_id];
                choices.push(theChoice);
            }
        }
        else {
            choices.push(theChoice);
        }
    });

    return choices;
};

export const loadCartInformation = (uid, currentLocation, cart, navigation, token, navigateToCheckout = true) => {
    return (dispatch) => {
        
        const params = {
            token,
            uid,
            lid: currentLocation.location.id,
            cart
        }

        axios.post(API_URL+'/api/order/cart', params)
            .then(function(res) {

                if (res.data.status == "success") {

                    dispatch(cartInfoUpdate({ prop: 'subtotal', value: parseFloat(res.data.data.cart.subtotal)}));
                    dispatch(cartInfoUpdate({ prop: 'delivery_charge', value: parseFloat(res.data.data.cart.delivery_charge)}));
                    dispatch(cartInfoUpdate({ prop: 'fuel_surcharge', value: parseFloat(res.data.data.cart.fuel_surcharge)}));
                    dispatch(cartInfoUpdate({ prop: 'additional_charge', value: parseFloat(res.data.data.cart.additional_charge)}));
                    dispatch(cartInfoUpdate({ prop: 'taxes', value: parseFloat(res.data.data.cart.taxes)}));
                    dispatch(cartInfoUpdate({ prop: 'total', value: parseFloat(res.data.data.cart.total)}));
                    if (res.data.data.cart.loyaltyRewards) {
                        dispatch(cartInfoUpdate({ prop: 'loyalty_rewards', value: res.data.data.cart.loyaltyRewards}));
                    }
                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));

                    if (currentLocation.location.payment_type == "IN STORE") {
                        dispatch(cartInfoUpdate({ prop: 'payment_method', value: 'in_store'}));
                    }
                    else {
                        dispatch(cartInfoUpdate({ prop: 'payment_method', value: 'online_payment'}));
                    }
                    
                    dispatch(cartInfoUpdate({ prop: 'promo_id', value: res.data.data.cart.promo_id ?? 0}));
                    dispatch(cartInfoUpdate({ prop: 'promo_amount', value: parseFloat(res.data.data.cart.promo_total ?? 0)}));
                    dispatch(cartInfoUpdate({ prop: 'promoError', value: res.data.data.cart.promo_error_message ?? res.data.data.cart.promoError}));
                    dispatch(cartInfoUpdate({ prop: 'promo_code', value: res.data.data.cart.promo_code ?? res.data.data.cart.promo_code}));

                    if (navigateToCheckout) {
                        dispatch(setCartPanel('checkout'));
                        // navigation.navigate("ViewCheckout", {
                        //     viewCCInfo: "false"
                        // });
                    }
                }
                else {
                    // @TODO: get some sort of error checking here
                    console.log("It was an error, here is the result:");
                    console.log(res);
                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                }
            })
            .catch(function(err) {
                // @TODO: get some sort of error checking here
                let message = err.response.data.message ?? 'There was an issue continuing with your order.';

                setTimeout(() => {
                    alert(message ?? 'setsetst');
                }, 100);

                dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
            });
    };
};

export const getDeliveryCharge = (uid, currentLocation, cart, navigation, token) => {
    return (dispatch) => {
        
        const params = {
            token,
            uid,
            lid: currentLocation.location.id,
            cart,
            address: cart.delivery_address,
            instructions: cart.delivery_instructions
        }
        dispatch(cartInfoUpdate({ prop: 'locationError', value: '' }));

        axios.post(API_URL+'/api/order/deliverycharge', params)
            .then(function(res) {
                if (res.data.status == "success") {

                    dispatch(cartInfoUpdate({ prop: 'subtotal', value: parseFloat(res.data.data.cart.subtotal)}));
                    dispatch(cartInfoUpdate({ prop: 'delivery_charge', value: parseFloat(res.data.data.delivery_charge)}));
                    dispatch(cartInfoUpdate({ prop: 'fuel_surcharge', value: parseFloat(res.data.data.cart.fuel_surcharge)}));
                    dispatch(cartInfoUpdate({ prop: 'additional_charge', value: parseFloat(res.data.data.cart.additional_charge)}));
                    dispatch(cartInfoUpdate({ prop: 'taxes', value: parseFloat(res.data.data.cart.taxes)}));
                    dispatch(cartInfoUpdate({ prop: 'total', value: parseFloat(res.data.data.cart.total)}));
                    if (res.data.data.cart.loyaltyRewards) {
                        dispatch(cartInfoUpdate({ prop: 'loyalty_rewards', value: res.data.data.cart.loyaltyRewards}));
                    }

                    if (currentLocation.location.payment_type == "IN STORE") {
                        dispatch(cartInfoUpdate({ prop: 'payment_method', value: 'in_store'}));
                    }
                    else {
                        dispatch(cartInfoUpdate({ prop: 'payment_method', value: 'online_payment'}));
                    }
                    
                    dispatch(cartInfoUpdate({ prop: 'promo_id', value: res.data.data.cart.promo_id ?? 0}));
                    dispatch(cartInfoUpdate({ prop: 'promo_amount', value: parseFloat(res.data.data.cart.promo_total ?? 0)}));
                    dispatch(cartInfoUpdate({ prop: 'promoError', value: res.data.data.cart.promo_error_message ?? res.data.data.cart.promoError}));
                    dispatch(cartInfoUpdate({ prop: 'promo_code', value: res.data.data.cart.promo_code ?? res.data.data.cart.promo_code}));

                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                    dispatch(setCartPanel('checkout'));
                    // navigation.navigate("ViewCheckout", {
                    //     viewCCInfo: "false"
                    // });
                }
                else {
                    // @TODO: get some sort of error checking here
                    // @NOTE: error lives in res.data.message
                    console.log("It was an error, here is the result:");
                    console.log(res);
                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                    dispatch(cartInfoUpdate({ prop: 'locationError', value: "We're sorry, but we do not deliver to that location." }));
                }
            })
            .catch(function(err) {                
                
                if (err.response.status == 400) {
                    
                    let message = err.response.data.message ?? 'There was an issue continuing with your order.';

                    setTimeout(() => {
                        alert(message);
                    }, 100);

                }
                else {
                    console.log("It was an error, here is the server error:");
                    console.log(err.response);
                    console.log(err);
                }

                dispatch(cartInfoUpdate({ prop: 'loading', value: false }));

            });
    };
};

export const applyPromo = (uid, currentLocation, cart) => {
    return (dispatch) => {
        
        const params = {
            uid,
            lid: currentLocation.location.id,
            cart,
            promocode: cart.promo_code
        };

        axios.post(API_URL+'/api/order/applypromo', params)
            .then(function(res) {
                if (res.data.status == "success") {

                    dispatch(cartInfoUpdate({ prop: 'promo_id', value: parseFloat(res.data.data.cart.promo_id)}));
                    dispatch(cartInfoUpdate({ prop: 'promo_amount', value: parseFloat(res.data.data.cart.promo_total)}));
                    dispatch(cartInfoUpdate({ prop: 'promo_delivery_amount', value: parseFloat(res.data.data.cart.promo_delivery_total)}));
                    dispatch(cartInfoUpdate({ prop: 'taxes', value: parseFloat(res.data.data.cart.taxes)}));
                    dispatch(cartInfoUpdate({ prop: 'total', value: parseFloat(res.data.data.cart.total)}));
                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                }
            })
            .catch(function(err) {
                if(err.response.status == "422"){
                    dispatch(cartInfoUpdate({ prop: 'promoError', value: err.response.data.message }));
                }else{
                    dispatch(cartInfoUpdate({ prop: 'promoError', value: "We're sorry, but there was an error processing your promo code. Our support has been notified of the issue." }));
                }

                // @TODO If we encounter a 500 error the taxes/total values will not be available to us
                // The taxes/total available in cart will be either valid or set to what the previous promo code set them to but maybe that will be our fallback?
                // Alternatively we could save the original values for that in the cart object and only retrieve them in this circumstance
                dispatch(cartInfoUpdate({ prop: 'promo_id', value: 0}));
                dispatch(cartInfoUpdate({ prop: 'promo_amount', value: 0.00}));
                dispatch(cartInfoUpdate({ prop: 'promo_delivery_amount', value: 0.00}));
                dispatch(cartInfoUpdate({ prop: 'taxes', value: parseFloat(err.response.data.data.cart.taxes)}));
                dispatch(cartInfoUpdate({ prop: 'total', value: parseFloat(err.response.data.data.cart.total)}));
                dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
            });
    };
};

export const selectLoyaltyReward = (uid, currentLocation, cart, reward_id) => {
    return (dispatch) => {

        const params = {
            uid,
            lid: currentLocation.location.id,
            cart: {
                ...cart,
                selectedReward: reward_id
            },
        };

        axios.post(API_URL+'/api/order/applyloyaltyreward', params)
            .then(function(res) {
                if (res.data.status == "success") {

                    dispatch(cartInfoUpdate({ prop: 'selectedReward', value: parseFloat(reward_id)}));
                    dispatch(cartInfoUpdate({ prop: 'loyalty_redeem_amount', value: parseFloat(res.data.data.cart.loyalty_redeem_amount)}));
                    dispatch(cartInfoUpdate({ prop: 'taxes', value: parseFloat(res.data.data.cart.taxes)}));
                    dispatch(cartInfoUpdate({ prop: 'total', value: parseFloat(res.data.data.cart.total)}));
                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                }
                else {
                    dispatch(cartInfoUpdate({ prop: 'loyaltyError', value: res.data.data.message }));
                    dispatch(cartInfoUpdate({ prop: 'selectedReward', value: 0}));
                    dispatch(cartInfoUpdate({ prop: 'loyalty_redeem_amount', value: parseFloat(res.data.data.promo_total)}));
                    dispatch(cartInfoUpdate({ prop: 'taxes', value: parseFloat(res.data.data.new_taxes)}));
                    dispatch(cartInfoUpdate({ prop: 'total', value: parseFloat(res.data.data.new_total)}));
                    dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
                }
            })
            .catch(function(err) {
                dispatch(cartInfoUpdate({ prop: 'loyaltyError', value: "We're sorry, but there was an error processing your loyalty reward. Our support has been notified of the issue." }));
                dispatch(cartInfoUpdate({ prop: 'selectedReward', value: 0}));
                dispatch(cartInfoUpdate({ prop: 'loyalty_redeem_amount', value: 0.00}));
                dispatch(cartInfoUpdate({ prop: 'loading', value: false }));
            });
    };
};